import React, { useContext } from 'react';
import style from './style';
import Attribute from "../../AddContext/steps/ContextAttributes/Attribute";
import {useFormContext} from "react-hook-form";
import { PrivilegeEnum, RoleBasedAccessControlContext } from '../../../../services/common/RolesUtils';


const Attributs = ({onEditAttribute, isContextArchived}) => {
  const {classes} = style();
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const {
    watch
  } = useFormContext();

  const contextAttributes = watch('contextAttributes');


  return <div className={classes.root}>
    <div className={classes.container}>
      {[...contextAttributes]
        .sort((a, b) => (a.label || '').localeCompare(b.label || '', undefined, { sensitivity: 'base' }))
        .map((contextAttribute) => (
          <Attribute
            key={contextAttribute.id || contextAttribute.label}
            contexteAttribute={contextAttribute}
            onValidateSuccess={onEditAttribute}
            currentValue={contextAttributes.find((c) => c.label === contextAttribute.label)}
            disabled={
              isContextArchived ||
              !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_CONTEXT_ATTRIBUTES)
            }
          />
        ))}

    </div>
  </div>
}

export default Attributs;